import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import H2Font from "Root/profile/components/common/H2Font";
import styles from "./styles.module.scss";
import useCheckoutReccomendations from "./useCheckoutRecommendations";
import CheckoutResultsProduct from "../CheckoutResultsProduct";
import Loading from "Components/Loading";
import Science from "./images/Science.svg";
import IngredientsImg from "./images/ingredients.svg";
import CleanFlavors from "./images/Clean.svg";
import RegFont from "Root/profile/components/common/RegFont";
import { useEffect, useState } from "react";
import { AB_CHECKOUT_BULLET_POINTS } from "Root/utils/experiment";
import { apiGetABtest } from "Root/api/apiCommon";
const icons = [
    {
        title: "Science Backed",
        img: Science,
    },
    {
        title: "No Artificial Flavors",
        img: CleanFlavors,
    },
    {
        title: "Clean Ingredients",
        img: IngredientsImg,
    },
];
const CheckoutRecommendations = () => {
    const { userCart, getIngredient } = useCheckoutReccomendations();
    const [isInAbTest, setIsInAbTest] = useState(false);
    const getAbTestResults = async () => {
        const result = await apiGetABtest(AB_CHECKOUT_BULLET_POINTS);
        setIsInAbTest(result === "B");
    };
    useEffect(() => {
        getAbTestResults();
    }, []);
    return (_jsxs("div", { className: styles.recommendations, children: [_jsx(H2Font, { children: "Your Recommendations" }), _jsx("div", { className: styles.products, children: userCart.length ? (userCart.map((item) => (_jsx(CheckoutResultsProduct, { cartItem: item, ingredientInfo: getIngredient(item.item_type), isInBulletPointsABTest: isInAbTest }, item.product_id)))) : (_jsxs(_Fragment, { children: [_jsx(Loading, {}), _jsx(Loading, {}), _jsx(Loading, {})] })) }), _jsx("div", { className: styles.icons, children: icons.map((icon) => (_jsxs("div", { className: styles.icon, children: [_jsx("img", { src: icon.img }), _jsx(RegFont, { children: icon.title })] }, icon.title))) })] }));
};
export default CheckoutRecommendations;
